import React from 'react';
import styled from 'styled-components';
import { Heading3 } from '@qover/typography';
import { PrimaryButton } from '@qover/molecules';
import { Modal } from './Modal';

const ModalContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`;

const ErrorMessage = styled(Heading3)`
  font-weight: bold;
  text-align: center;
  padding-bottom: 50px;
  color: ${({ theme }) => theme.colors.error()};
`;

type ErrorModalProps = {
  onButtonClick: () => void;
  errorMessage: React.ReactNode;
  buttonText: React.ReactNode;
};

export const ErrorModal: React.FC<ErrorModalProps> = props => (
  <Modal hideOverflow>
    <ModalContainer>
      <ErrorMessage>{props.errorMessage}</ErrorMessage>
      <PrimaryButton onClick={() => props.onButtonClick()}>
        {props.buttonText}
      </PrimaryButton>
    </ModalContainer>
  </Modal>
);

export default ErrorModal;
